import { setupAppAnalytics } from './app-analytics.js'
import { setupAppClientSearchMinisearch } from './app-client-search-minisearch.js'
import { setupAppClipboardWeb } from './app-clipboard-web.js'
import { setupAppFontsArimo } from './app-fonts-arimo.js'
import { setupAppHttp } from './app-http.js'
import { setupAppI18nReactI18next } from './app-i18n-react-i18next.js'
import { setupAppIconsMolecule } from './app-icons-molecule.js'
import { setupAppKeyboardShortcutsHotkeys } from './app-keyboard-shortcuts-hotkeys.js'
import { setupAppQueryTanstack } from './app-query-tanstack.js'
import { setupAppRoutingReactRouter } from './app-routing-react-router.js'
import { setupAppStateZustand } from './app-state-zustand.js'
import { setupAppStorageLocalstorage } from './app-storage-localstorage.js'
import { setupAppThemeCssVariables } from './app-theme-css-variables.js'
import { setupAuthDefault } from './auth-default.js'

export { i18nProvider } from './app-i18n-react-i18next.js'
export { themeProvider } from './app-theme-css-variables.js'
export { authClient } from './auth-default.js'

/**
 * Initialize the providers needed by every route (landing included).
 *
 * Deliberately excluded so they code-split out of the landing entry bundle:
 *   - IDE-only bonds (chat, code editor, workspace, live preview) →
 *     {@link import('./ide.js').setupIdeProviders}, wired by the Workspace route.
 *   - ClassMap / styling bonds (tailwind-merge + UIClassMap) →
 *     {@link import('./ui.js').setupUiProviders}, wired by every non-landing
 *     lazy route (the landing is hand-written CSS and never uses ClassMap).
 *
 * Call this during application startup, before mounting the app.
 */
export function setupProviders(): void {
  setupAppHttp()
  setupAppFontsArimo()
  setupAppI18nReactI18next()
  setupAppRoutingReactRouter()
  setupAppStateZustand()
  setupAppStorageLocalstorage()
  setupAppThemeCssVariables()
  setupAppIconsMolecule()
  setupAuthDefault()
  setupAppAnalytics()
  setupAppKeyboardShortcutsHotkeys()
  setupAppClientSearchMinisearch()
  setupAppClipboardWeb()
  setupAppQueryTanstack()
}
